import { getSanitizedStatement } from './getSanitizedStatement';

const SEPARATOR = '/';
const YEAR_LENGTH = 4;

export const formatStatement = (statement: string): string => {
    const sanitizedStatement = getSanitizedStatement(statement);
    const year = sanitizedStatement.substring(0, YEAR_LENGTH);
    const number = sanitizedStatement.substring(YEAR_LENGTH);

    return `${year}${SEPARATOR}${number}`;
};
